import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Input,
} from 'reactstrap';
import { useIntl } from 'react-intl';

const AdminBulkActionsSelector = ({
  actions,
  disabled,
  isApplyDisabled,
  handleSelectAction,
}) => {
  const intl = useIntl();

  const [action, setAction] = useState('');
  const applyDisabled = disabled || !action || isApplyDisabled(action);

  return (
    <div className="bulk-actions">
      <Input
        type="select"
        className="custom-select"
        name="bulk-actions"
        bsSize="sm"
        value={action}
        onChange={(e) => { setAction(e.target.value); }}
      >
        <option value="">
          {intl.formatMessage({ defaultMessage: 'Bulk actions' })}
        </option>
        {actions.map(a => (
          <option key={a.id} value={a.id}>
            {a.name}
          </option>
        ))}
      </Input>
      <Button
        size="sm"
        disabled={applyDisabled}
        onClick={() => {
          handleSelectAction(action, () => {
            setAction('');
          });
        }}
      >
        {intl.formatMessage({ defaultMessage: 'Apply' })}
      </Button>
    </div>
  );
};

AdminBulkActionsSelector.propTypes = {
  actions: PropTypes.array.isRequired,
  disabled: PropTypes.bool.isRequired,
  isApplyDisabled: PropTypes.func,
  handleSelectAction: PropTypes.func.isRequired,
};

AdminBulkActionsSelector.defaultProps = {
  isApplyDisabled: () => false,
};

export default AdminBulkActionsSelector;
